import React from 'react';
import MenuItem from './menuItem.jsx';

export default class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            entries: [
                {
                    url: '/parcels/list',
                    title: 'Мои посылки',
                    className: 'fa fa-inbox',
					itemType: 'nav',
                    isActive: (m, l) => this.isParcelsLink(m, l)
                },
                {
                    url: '/parcels/new',
                    title: 'Создать посылку',
                    className: 'fa fa-envelope-o',
					itemType: 'nav',
                    restrictRoles: ['Author', 'Coordinator']
                },
                {
                    title: 'Администрирование',
                    className: 'fa fa-cogs',
					itemType: 'sub',
                    restrictRoles: ['Admin'],
                    childs: [
                        {
                            url: '/admin/users/list',
                            title: 'Пользователи',
                            className: 'fa fa-users',
							itemType: 'nav',
                            isActive: (m, l) => this.isAdminUsersLink(m, l)
                        }
                    ]
                },
                {
                    url: '/files/Инструкция mailroom.me.pdf',
                    title: 'Инструкция пользователя',
                    className: 'fa fa-info',
					itemType: 'file'
                }
            ]
        };
    }

    isParcelsLink(match, location) {
        let isNewParcel = location.pathname.startsWith('/parcels/new');
        let isParcels = location.pathname.startsWith('/parcels/');
        return isParcels && !isNewParcel;
    }

    isAdminUsersLink(match, location) {
        let isUsers = location.pathname.startsWith('/admin/users/');
        return isUsers;
    }

    render() {
        let location = this.props.location;
        let childs = this.state.entries.map(function (entry, ind) {
            return <MenuItem key={ind} entry={entry} />
        });

        return (
            <aside className="main-sidebar">
                <section className="sidebar">
                    <ul className="sidebar-menu tree" data-widget="tree">
                        {childs}
                    </ul>
                </section>

				<div className="sidebar-form sidebar-form-alert">
					<div className="alert alert-info">
						Пожалуйста, после печати накладной самостоятельно вложите ваше отправление в конверт. Вы можете найти их на ресепшн, а также в общих зонах офиса. 
						Распечатанную накладную необходимо поместить в специальный карман конверта.
					</div>
				</div>
            </aside>
        );
    }
};


// WEBPACK FOOTER //
// ./App/menu/menu.jsx